<template>
  <v-card :color="tableColor" elevation="0">
    <Table
      :actionBarButtons="actionBarButtons"
      :cols="cols"
      :hasExportCSV="false"
      :hasExportXLSX="false"
      :loading="loading"
      :rows="rows"
      :totalItems="totalItems"
      @changePage="handleChangePage"
      @contextmenu="contextmenu"
    />

    <FormModal
      :cols="cols"
      :opened.sync="formDialog.opened"
      :title="formDialog.editing ? 'Editar plataforma' : 'Adicionar plataforma'"
      :value.sync="formDialog.data"
      @save="doSave"
    />
  </v-card>
</template>

<script>
import Table from "@/components/table-v.vue";
import FormModal from "@/components/form-modal.vue";
import { mapGetters } from "vuex";
import { AnyAdmin } from "@/core/enums/user-types";
import { TiposResponsaveisEnum } from "../../responsaveis/responsaveis.types";

export default {
  components: {
    Table,
    FormModal
  },
  data() {
    return {
      loading: false,
      rows: [],
      totalItems: undefined,
      formDialog: {
        opened: false,
        data: {},
        editing: false
      }
    };
  },
  computed: {
    ...mapGetters(["clientId", "user"]),
    hasAdminRole() {
      return this.user.nivel_hierarquico?.tipo_id === TiposResponsaveisEnum.ADMINISTRADOR;
    },
    canManage() {
      return this.hasAdminRole || AnyAdmin.includes(this.user.tipo_usuario);
    },
    actionBarButtons() {
      const buttons = [
        {
          text: "Atualizar",
          icon: "mdi-refresh",
          action: () => {
            this.doLoad();
          }
        }
      ];

      if (this.canManage) {
        buttons.push({
          text: "Adicionar",
          icon: "mdi-plus-box-outline",
          action: () => {
            this.formDialog.editing = false;
            this.formDialog.data = {};
            this.formDialog.opened = true;
          }
        });
      }

      return buttons;
    },
    cols() {
      return [
        {
          key: "plataforma",
          name: "Plataforma",
          type: this.$fieldTypes.TEXT,
          rules: [{ rule: "required" }, { rule: "max", params: { size: 255 } }]
        }
      ];
    },
    resourceUrl() {
      return `/v1/ativacaoped/${this.clientId}/plataformas`;
    }
  },
  async created() {
    await this.doLoad();
  },
  methods: {
    async doLoad(query = "") {
      this.loading = true;

      try {
        const resource = this.apiResource(this.resourceUrl);
        const result = await resource.get({ query });

        this.rows = Array.isArray(result) ? result : result?.data || [];
        this.totalItems = result?.total ?? this.rows.length;
      } catch (error) {
        this.rows = [];
        this.totalItems = undefined;

        if (!error.isAxiosError) {
          this.notify(error);
        }
      } finally {
        this.loading = false;
      }
    },
    handleChangePage({ page, perPage }) {
      this.doLoad(`page=${page}&per_page=${perPage}`);
    },
    contextmenu(row, event) {
      setTimeout(() => {
        this.showContext({
          left: event.clientX,
          top: event.clientY,
          val: row,
          col: {},
          menu: [
            {
              name: "Editar",
              icon:
                "v-icon notranslate mr-3 mdi mdi-square-edit-outline theme--light",
              cb: (row) => {
                this.formDialog.editing = true;
                this.formDialog.data = { ...row };
                this.formDialog.opened = true;
              }
            }
          ]
        });
      }, 100);
    },
    async doSave(data) {
      const invalid = this.cols.some(({ valid }) => !valid || !valid());

      if (invalid) {
        return;
      }

      try {
        const resource = this.apiResource(this.resourceUrl);
        const id = this.formDialog.editing ? data.id : undefined;
        await resource.save(data, id);

        this.$notify({
          group: "geral",
          duration: 5000,
          type: "sucess",
          title: this.formDialog.editing ? "Edição concluída" : "Cadastro concluído",
          text: this.formDialog.editing ? "Registro atualizado com sucesso." : "Registro criado com sucesso."
        });

        this.formDialog.opened = false;
        this.formDialog.data = {};
        await this.doLoad();
      } catch (error) {
        if (!error.isAxiosError) {
          this.notify(error);
        }
      }
    }
  }
};
</script>
